import * as PropTypes from "prop-types";
import {cn} from "./utils";
import React from "react";
import Paper from "./Paper";

export default function Browser(props) {
  const { className, selected, imageSrcs = [], compact, onClick } = props;
  const [selectedImage, setSelectedImage] = React.useState(selected || imageSrcs?.[0]);
  React.useEffect(() => {
    setSelectedImage(selected || imageSrcs[0]);
  }, [selected]);

  if (!selectedImage) return null;

  if (compact) {
    return (
      <div className={cn(" h-[116px] flex items-center gap-2 shrink-0 p-2 overflow-auto", className)}>
        {imageSrcs.map((image) => (
          <Paper
            key={image.id}
            style={{ border: image.id === selectedImage.id ? "4px solid #224b99" : "" }}
            onClick={() => {
              setSelectedImage(image);
              onClick(image);
            }}
            className="w-[92px] grow-0 shrink-0 h-full flex items-center justify-center p-0 overflow-hidden cursor-pointer border shadow-none hover:shadow"
          >
            <img src={image.data} className="max-w-[92px] max-h-[92px]" />
          </Paper>
        ))}
      </div>
    );
  }

  return (
    <div className={cn("w-[260px] h-full flex flex-col gap-[24px] shrink-0 border-r overflow-auto", className)}>
      {/* <header className="flex items-center justify-between sticky top-0 bg-[#fff] p-4">
        <p className="text-[14px]">Add Files</p>
        <div className="flex items-center gap-[34px] text-[16px]">
          <LuPaperclip className="cursor-pointer" />
          <LuCamera className="cursor-pointer" />
        </div>
      </header> */}
     <div
  style={{
    display: "grid",
    gridTemplateColumns: "repeat(1, 1fr)",
    gap: "10px",
    padding: "10px",
  }}
>
  {imageSrcs.map((image) => (
    <Paper
      key={image.id}
      style={{
        border: image.id === selectedImage.id ? "4px solid #224b99" : "none",
        width: "100px",
        height: "100px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "0",
        overflow: "hidden",
        cursor: "pointer",
        boxShadow: "none",
        transition: "box-shadow 0.3s ease",
      }}
      onMouseEnter={(e) =>
        (e.currentTarget.style.boxShadow = "0px 4px 6px rgba(0, 0, 0, 0.1)")
      }
      onMouseLeave={(e) => (e.currentTarget.style.boxShadow = "none")}
      onClick={() => {
        setSelectedImage(image);
        onClick(image);
      }}
    >
      <img
        src={image.data}
        style={{
          maxWidth: "92px",
          maxHeight: "92px",
        }}
      />
    </Paper>
  ))}
</div>

    </div>
  );
}

Browser.propTypes = {
  className: PropTypes.string,
  selected: PropTypes.object,
  imageSrcs: PropTypes.array,
  onClick: PropTypes.func,
  compact: PropTypes.bool,
};

// function File
